import React from 'react';
import Chart from 'react-apexcharts';
import { alignedBox } from './AlignedBox';
import { denormalizeFieldName } from './utils';
import { generateColors } from './colors';
import { actualCurrencyFormatter, getFormatterFromData } from './formatters';

export const groupDataForAreaChart = (data, xField, yField) =>
  data.reduce((acc, row) => {
    const key = row[xField] || 'Unknown';
    acc[key] = (acc[key] || 0) + (row[yField] || 0);
    return acc;
  }, {});

export const AreaChart = ({ title, data, xField, yField }) => {
  // Sort by xField if it's temporal or numeric for proper area chart sequencing
  const sortedData = [...data].sort((a, b) => {
    const aVal = a[xField];
    const bVal = b[xField];
    if (aVal < bVal) return -1;
    return aVal > bVal ? 1 : 0
  });

  const categories = sortedData.map(row => row[xField]);
  const seriesData = sortedData.map(row => row[yField] || 0);

  const formatter = getFormatterFromData(seriesData);

  const options = {
    chart: {
      type: 'area',
      zoom: { enabled: false },
    },
    xaxis: {
      type: 'category',
      categories,
      labels: {
        style: {
          fontSize: '10px',
        },
      },
      title: {
        text: denormalizeFieldName(xField),
        style: {
          fontSize: '10px',
          fontWeight: 'normal',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '10px',
        },
        formatter,
      },
      title: {
        text: denormalizeFieldName(yField),
        style: {
          fontSize: '10px',
          fontWeight: 'normal',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.99,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    colors: generateColors(1),
    tooltip: {
      y: {
        formatter: actualCurrencyFormatter,
      },
    },
  };

  const series = [
    {
      name: yField,
      data: seriesData,
    },
  ];

  return alignedBox(title, (
    <Chart options={options} series={series} type="area" />
  ));
};
